import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class PlanSalesService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/plan_sales", { params: toSnakeCase(params) });
  }

  fetch(id, includes = []) {
    return securedAxiosInstance.get(`/plan_sales/${id}`, { params: { includes } });
  }

  updateSeller(planSaleFriendlyId, sellerId) {
    return securedAxiosInstance.put(`/plan_sales/${planSaleFriendlyId}/update_seller`, { seller_id: sellerId });
  }

  fetchPaymentMethod(planSaleId) {
    return securedAxiosInstance.get(`/plan_sales/${planSaleId}/payment_method`);
  }

  fetchUpdatePaymentMethodLink(planSaleId) {
    return securedAxiosInstance.get(`/plan_sales/${planSaleId}/payment_method/update_link`);
  }

  cancelPlanSale(planSaleId, cancellationReason, feedbackMessage, cancellationDate) {
    return securedAxiosInstance.put(
      `/plan_sales/${planSaleId}/cancel`,
      toSnakeCase({
        planSale: { cancellationReason, feedbackMessage, cancellationDate },
      }),
    );
  }

  reactivatePlanSale(planSaleId) {
    return securedAxiosInstance.put(`/plan_sales/${planSaleId}/reactivate`);
  }

  updatePlanSale(planSaleId, planSaleInformations) {
    return securedAxiosInstance.put(`/plan_sales/${planSaleId}`, {
      plan_sale: planSaleInformations,
    });
  }

  getBillingInvoice(planSaleBillingId) {
    return securedAxiosInstance.get(`/plan_sale_billings/${planSaleBillingId}/invoice`);
  }

  getRenewLink(planSaleId) {
    return securedAxiosInstance.get(`/plan_sales/${planSaleId}/renewal_link`);
  }

  renewPlanSale(planSaleId) {
    return securedAxiosInstance.put(`/plan_sales/${planSaleId}/renewal`);
  }

  sendConfirmationEmail(planSaleId) {
    return securedAxiosInstance.post(`/plan_sales/${planSaleId}/send_confirmation`);
  }

  exchangeProduct(friendlyId, { referenceId, title, price, purchaseDate }) {
    return securedAxiosInstance.put(
      `/plan_sales/${friendlyId}/exchange_product`,
      toSnakeCase({ referenceId, title, price, purchaseDate }),
    );
  }
}

export default new PlanSalesService();
